export const FETCH_MAP_FLOOR = "FETCH_MAP_FLOOR"